<template>
  <section>
    
      <div class="row jobs">
          <h3>Current Openings :</h3>
          <hr />
          <div v-if="jobs.length">
            <div
            class="col-md-12 col-sm-12 service"
            v-for="(job,i) in jobs"
            :key="i">
            <i class="fa big-fa fa-briefcase"></i>
            <h4><strong>{{job.title.rendered}}</strong></h4>
            <article>
              <!-- {{career.content.rendered}} -->
              <span class="data-cms" v-html="job.content.rendered"></span>
              <a :href="getEmailParams(job)"
                ><button type="button" class="btn btn-primary">
                  Apply Now
                </button></a
              >
            </article>
            <hr />
          </div>
          </div>
        </div>
    
    
    </section>
</template>
    
    
    
    <script>
const axios = require("axios")
export default {
  data(){
    return{
      jobs:[]
    }
  },
  mounted(){
    this.getCareerListings()
  },
  methods:{
    getEmailParams(job){
      
      return `mailto:info@compu-info.com?subject=${job.title.rendered}&anp;body=`
    },
    async getCareerListings(){
      var res = await axios({method:"get",url:"https://compu-info-1abfbc.ingress-comporellon.easywp.com/wp-json/wp/v2/posts?categories=2"})
      this.jobs = res.data
    }
  }
}
</script>
